import React from 'react';

const InputField = ({ 
  type, 
  value, 
  placeholder, 
  isRequired, 
  onChangeHandler,
  className,
  label,
  formValues
}) => {
  if (type === "submit") {
    return (
      <input
        className={className}
        type="submit"
        value={label || "Submit"}
        disabled={formValues && formValues.some(value => !value)}
      />
    );
  }

  return (
    <input
      className={className}
      type={type}
      value={value}
      placeholder={placeholder}
      required={isRequired}
      onChange={(e) => onChangeHandler(e.target.value)}
    />
  );
};

export default InputField;
